import {
  BETTER_DOC_ROUTE_PATH,
  SESSION_ID_SEARCH_PARAMETER,
} from "@/modules/admin/better-doc/constants/better-doc-constants"

export const buildBetterDocSessionLink = (sessionId: number) =>
  `${BETTER_DOC_ROUTE_PATH}?${SESSION_ID_SEARCH_PARAMETER}=${sessionId}`
